import styled from 'styled-components'

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SliderLabel = styled.span`
  ${({ theme }) => theme.fonts.labelMD}
  color: ${({ theme }) => theme.colors.neutralL4};
`

export const RangeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  height: 48px;
  background: ${({ theme }) => theme.colors.secondaryL1};
  border-radius: 10px;
  padding: 0 16px;
`

export const RangeText = styled.span`
  ${({ theme }) => theme.fonts.infoMD}
  color: ${({ theme }) => theme.colors.neutralL5};
  min-width: 44px;
  white-space: nowrap;
`

export const RangeLeading = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Range = styled.input<{ percent: number }>`
  -webkit-appearance: none;
  appearance: none;
  flex: 1;
  // Firefox gives the range a 160px intrinsic width, and a flex item does not shrink below it
  // by default: in a narrow row the track overflowed past the row's edge.
  min-width: 0;
  height: 4px;
  border-radius: 2px;
  outline: none;
  cursor: pointer;
  background: ${({ theme, percent }) =>
    `linear-gradient(to right, ${theme.colors.primary} 0%, ${theme.colors.primary} ${percent}%, ${theme.colors.secondaryL2} ${percent}%, ${theme.colors.secondaryL2} 100%)`};

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    background: ${({ theme }) => theme.colors.neutralL5};
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 100%;
    background: ${({ theme }) => theme.colors.neutralL5};
    cursor: pointer;
  }
`
